<script setup>
    import { ref } from "vue";
import PageHeader from '@/Components/PageHeader.vue';
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Link, Head } from '@inertiajs/inertia-vue3';
    import BaseButton from "@/Components/BaseButton.vue";
    import { mdiPlusCircle } from "@mdi/js";
    import CardBox from "@/Components/CardBox.vue";
    import TableSingle from "@/Components/TableSingle.vue";
    
    defineProps({
        levels: Array,
        select_level: Array,
        select_level2: Array
    });
    const rutaprefijo = ref('level');
    const modulo = ref('Nivel');
</script>

<template>
    <Head title="Nivel escolar" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Nivel / Subnivel escolar" />
        </template>


        <div class="py-8 lg:py-10">
            <div class="mx-auto sm:px-6 lg:px-8 px-4">
                <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        <CardBox class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable isRef ya está por defecto en modulo Nivel -->
                            <TableSingle :modulo="modulo" :data="levels" :select1="select_level" :select2="$page.props.auth.user.id_rol <= 3 ? select_level2 : []" :ruta="rutaprefijo"/>
                        </CardBox>
                        
                    </div>
                </div>
          
        </div>
    </BreezeAuthenticatedLayout>
</template>
